import { DueDateCalendarDateValue } from "@smartsuite/react-ui/lib";
import { DueDateValue } from "@smartsuite/types";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import parse from "date-fns/parse";

export const defaultDueDateValue = {
  from_date: {
    date: "",
    include_time: false,
  },
  to_date: {
    date: "",
    include_time: false,
  },
};

export const getDueDateValueString = (
  includeTime: boolean,
  date: string,
  timeFormat: string
): string => {
  const parsedDate = new Date(date);
  const timeFormatPart = timeFormat === "12h" ? "hh:mm a" : "HH:mm";

  return includeTime
    ? format(parsedDate, `MMMM dd, yyyy, ${timeFormatPart} (zzzz)`)
    : format(parsedDate, "MMMM dd, yyyy");
};

export const combineDateAndTime = (
  dateString: string,
  timeString: string,
  timeFormat: string
): string => {
  if (!dateString) return "";
  if (!timeString) return format(new Date(dateString), "yyyy-MM-dd'T'HH:mm:ss");

  const date = parse(dateString, "MMMM dd, yyyy", new Date());
  const timeDate = parse(timeString, timeFormat === "24h" ? "HH:mm" : "hh:mm a", new Date());
  if (isNaN(date.getTime()) || isNaN(timeDate.getTime())) {
    return "";
  }

  const combinedDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    timeDate.getHours(),
    timeDate.getMinutes()
  );

  return format(combinedDate, "yyyy-MM-dd'T'HH:mm:ss");
};

export const getTimeFromDateString = (dateString: string, timeFormat: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  return format(date, timeFormat === "24h" ? "HH:mm" : "hh:mm a");
};

export const getDefaultValueState = (value: DueDateValue): DueDateValue => {
  if (!value?.to_date?.date && !value?.from_date?.date) {
    return defaultDueDateValue;
  }
  return {
    from_date: value.from_date.date ? value.from_date : defaultDueDateValue.from_date,
    to_date: value.to_date.date ? value.to_date : defaultDueDateValue.to_date,
  };
};

export const getFormattedInputDate = (date: Date): string => {
  if (isValid(date)) {
    return format(date, "dd/MM/yyyy");
  }
  return "";
};

export const initDatesFromValue = (
  value: DueDateValue,
  timeFormat: string
): {
  fromDate: Date | null;
  endDate: Date | null;
  timeValues: DueDateCalendarDateValue;
  calendarDateValues: DueDateValue;
} => {
  const fromDateParsed = value.from_date.date ? new Date(value.from_date.date) : null;
  const endDateParsed = value.to_date.date ? new Date(value.to_date.date) : null;

  return {
    fromDate: value.from_date.date ? (value.from_date.date ? fromDateParsed : endDateParsed) : null,
    endDate: endDateParsed,
    timeValues: {
      from_date: value.from_date.include_time
        ? getTimeFromDateString(value.from_date.date ?? "", timeFormat)
        : "",
      to_date: value.to_date.include_time
        ? getTimeFromDateString(value.to_date.date ?? "", timeFormat)
        : "",
    },
    calendarDateValues: {
      from_date: {
        date: value.from_date.date ? format(new Date(value.from_date.date), "MMM dd, yyyy") : "",
        include_time: value.from_date.include_time,
      },
      to_date: {
        date: value.to_date.date ? format(new Date(value.to_date.date), "MMM dd, yyyy") : "",
        include_time: value.to_date.include_time,
      },
    },
  };
};
